module.exports = __webpack_public_path__ + "media/images/app/occasions/header-474fa68185cd5e510700230a2b79dfcf.webp";